import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, BadgeCheck } from 'lucide-react';
export function GuaranteeSection() {
  const companies = ['Mutual of Omaha', 'Transamerica', 'American Amicable', 'Senior Life Insurance'];
  return <section className="py-[50px] md:py-[80px] px-6 bg-brand-guarantee relative overflow-hidden" data-id="element-79">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-[100px] pointer-events-none" data-id="element-80"></div>

      <div className="max-w-[900px] mx-auto relative z-10 text-center" data-id="element-81">
        <FadeIn data-id="element-82">
          <div className="flex justify-center mb-8" data-id="element-83">
            <ShieldCheck className="w-24 h-24 text-brand-gold drop-shadow-lg" data-id="element-84" />
          </div>

          <h2 className="text-[32px] md:text-[36px] font-bold text-white mb-10 leading-tight" data-id="element-85">
            Respaldado por las Compañías <br className="hidden md:block" data-id="element-86" />
            de Seguros Más Sólidas del País
          </h2>

          <div className="text-[20px] text-white space-y-5 max-w-2xl mx-auto mb-12" data-id="element-87">
            <p data-id="element-88">No estás comprando un producto de internet.</p>
            <p data-id="element-89">
              Estás siendo respaldado por compañías de seguros con décadas de
              historia, reguladas por el estado, y obligadas por ley a cumplir
              cada centavo de tu póliza.
            </p>
          </div>
        </FadeIn>

        {/* Company Logos / Names */}
        <FadeIn delay={0.2} data-id="element-90">
          <div className="mb-12" data-id="element-91">
            <p className="text-[20px] text-white font-semibold mb-8" data-id="element-92">
              Compañías como:
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-93">
              {companies.map((company, index) => <div key={index} className="flex items-center gap-2 bg-white/5 border border-brand-gold/30 rounded-full px-5 py-3" data-id="element-94">
                  <span className="text-brand-gold text-lg" data-id="element-95">🛡️</span>
                  <span className="text-white font-semibold text-[16px] md:text-[18px]" data-id="element-96">
                    {company}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-97">
          <div className="text-[20px] text-white space-y-5 max-w-2xl mx-auto mb-12" data-id="element-98">
            <p data-id="element-99">
              Estas no son empresas nuevas. Algunas llevan más de 100 años
              pagándoles a las familias americanas exactamente lo que
              prometieron.
            </p>
            <p className="font-semibold" data-id="element-100">Tu familia no tendrá que rogar.</p>
            <p data-id="element-101">No tendrá que esperar.</p>
            <p data-id="element-102">No tendrá que pelear con nadie.</p>
            <p className="pt-4" data-id="element-103">
              Cuando llegue el momento,{' '}
              <strong className="text-brand-gold" data-id="element-104">el dinero estará ahí.</strong>
            </p>
            <div className="pt-4 space-y-2 text-white/90" data-id="element-105">
              <p data-id="element-106">Porque así funciona la ley.</p>
              <p data-id="element-107">Porque así funciona el seguro.</p>
              <p data-id="element-108">Porque así lo acordamos hoy.</p>
            </div>
          </div>
        </FadeIn>

        {/* Official Badge */}
        <FadeIn delay={0.4} data-id="element-109">
          <div className="inline-flex items-center gap-3 bg-white/5 border border-brand-gold/40 rounded-xl px-6 py-4 mb-10" data-id="element-110">
            <BadgeCheck className="w-8 h-8 text-brand-gold shrink-0" data-id="element-111" />
            <span className="text-white text-[15px] md:text-[16px] font-medium text-left" data-id="element-112">
              Licenciado y Regulado por el Estado | Departamento de Seguros
            </span>
          </div>
        </FadeIn>

        {/* Closing Line */}
        <FadeIn delay={0.5} data-id="element-113">
          <p className="text-brand-gold font-bold text-[20px] md:text-[22px] max-w-2xl mx-auto leading-relaxed mt-4 mb-8" data-id="element-114">
            "Esto no es una promesa. Es un contrato legal firmado por una
            compañía que lleva más de un siglo cumpliéndolo."
          </p>
        </FadeIn>

        {/* Legal Disclaimer */}
        <FadeIn delay={0.6} data-id="element-115">
          <p className="text-brand-lightGray/60 text-[13px] max-w-xl mx-auto" data-id="element-116">
            Todas las pólizas están reguladas por el Departamento de Seguros de
            tu estado. Los beneficios están garantizados por contrato.
          </p>
        </FadeIn>
      </div>
    </section>;
}